export const KEY_DATE = "Date";
export const KEY_CONTACT_ACCOUNT = "Contact/Account";
export const KEY_PHONE_NUMBER = "Phone Number";
export const KEY_USER = "User";
export const KEY_DIRECTION = "Direction";
export const KEY_SYSTEM_RESULT = "System Result";
export const KEY_USER_RESULT = "User Result";
export const KEY_DURATION = "Duration";
export const KEY_DESTINATION = "Destination";
export const KEY_CALL_TAGS = "Call Tags";
export const KEY_NOTE = "Note";
export const KEY_ACTIONS = "Actions";
